import { DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { format } from 'date-fns';
import { useCallback, useEffect, useId, useMemo } from 'react';

import moment from 'moment-timezone';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { errorIcon, getBgColor } from 'src/utils/icons';
import { convertDate } from 'src/utils/transformation';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';
import CustomDateInput from './CustomDateInput';

const ReceivedDate = () => {
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const handleInputChange = useContextSelector(InvoiceContext, (value) => value.handleInputChange);
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const errors = useContextSelector(InvoiceContext, (value) => value.errors);
  const hasError = useMemo(() => !!errors?.receivedDate.length, [errors?.receivedDate.length]);
  const id = useId();

  const formatDate = useMemo(
    () =>
      invoice?.receivedDate !== null
        ? format(convertDate(invoice?.receivedDate), 'MM/dd/yyyy').toString()
        : undefined,
    [invoice?.receivedDate]
  );

  const preventDefault = useCallback((e: any) => {
    e.preventDefault();
  }, []);

  useEffect(() => {
    document.getElementById(id)?.addEventListener('keyup', (e: any) => {
      const { value } = e.target;
      const newValue = value === 'month/day/year' ? '' : value;
      handleInputChange('_receivedDate')({
        value: newValue as string,
      } as unknown as DatePickerChangeEvent);
    });
    return document.getElementById(id)?.removeEventListener('keyup', (e) => {});
  }, [handleInputChange, id]);

  const handleReceivedDateChange = useCallback(
    (date: Date | null) => {
      handleInputChange('receivedDate')({
        value: date,
      } as unknown as DatePickerChangeEvent);
      if (date) {
        handleInputChange('_receivedDate')({
          value: moment(date).format('M/DD/YYYY'),
        } as unknown as DatePickerChangeEvent);
      }
    },
    [handleInputChange]
  );

  return (
    <PopUp
      content={
        <div className="m-1 max-w-[300px]">
          <PopUpContentWrapper type="Error" contents={errors?.receivedDate} />
        </div>
      }
      show={hasError}
      popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
      anchorAlign={{ horizontal: 'right', vertical: 'center' }}
    >
      <div className={`p-1 ${getBgColor(errors?.receivedDate)} text-[13px]`}>
        <p className="relative font-bold pb-1 flex items-center">
          Received Date {hasError && <span className="ml-1">{errorIcon}</span>}
        </p>

        {isInvoiceEditDisabled ? (
          <p>{formatDate}</p>
        ) : (
          <span onDragStart={preventDefault} onDragOver={preventDefault}>
            <CustomDateInput
              value={invoice?.receivedDate ? convertDate(invoice?.receivedDate) : undefined}
              valid={!hasError}
              id={id}
              onChange={handleReceivedDateChange}
            />
          </span>
        )}
      </div>
    </PopUp>
  );
};

export default ReceivedDate;
